import './index.scss';
import React from 'react';
import { InfoText } from 'Types/AppSettings';
import { Modal } from 'semantic-ui/semantic-ui-imports';
import IconButton from 'components/IconButton';
import { useTranslation } from 'react-i18next';

interface Props {
  infoText: InfoText;
  className?: string;
}

const classId = 'info-modal';

export default ({ className, infoText }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  return (
    <div className={`${classId} ${className}`}>
      <IconButton icon="info circle" onClick={() => setIsOpen(true)} />
      <Modal
        className={`${classId}__modal`}
        closeIcon
        onClose={() => setIsOpen(false)}
        open={isOpen}
      >
        <Modal.Header> {infoText.name}</Modal.Header>
        <Modal.Content>
          <p>{infoText.description}</p>
          {!!infoText.link && (
            <a href={`${infoText.link}`} target="_blank">
              {t('common.seeMore')}
            </a>
          )}
          {infoText.image && (
            <div className="info-modal__img-wrapper">
              <img
                src={infoText?.image}
                alt="stub placement"
                width="600px"
                height="auto"
              />
            </div>
          )}
        </Modal.Content>
      </Modal>
    </div>
  );
};
